/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Asi_Statement_AuthorInputs */

const en_home_quotes_asi_statement_author = /** @type {(inputs: Home_Quotes_Asi_Statement_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statement on Superintelligence`)
};

/**
* | output |
* | --- |
* | "Statement on Superintelligence" |
*
* @param {Home_Quotes_Asi_Statement_AuthorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_asi_statement_author = /** @type {((inputs?: Home_Quotes_Asi_Statement_AuthorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Asi_Statement_AuthorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_asi_statement_author(inputs)
});